import Vue from 'vue';
import { apiPath } from '@/api/constants';

export const Clients = Vue.resource(
  `${apiPath}/apps{/packageName}/oauth-clients/`,
  {},
  {
    getClients: { method: 'GET' },
  },
);

export const RedirectUrls = Vue.resource(
  `${apiPath}/apps{/packageName}/oauth-redirect-urls{/id}/`,
);
